import { create } from "zustand";

const useChooseSidebarClassesStore = create((set) => ({
  isOpen: false,
  programmeId: null,
  open: (programmeId) => set({ isOpen: true, programmeId }),
  close: () => set({ isOpen: false }),
}));

export default useChooseSidebarClassesStore;
